var parseHexColor = function (hex) {
    var match = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    if (!match) {
        throw new Error("Expected a 6-digit hex color, got \"".concat(hex, "\""));
    }
    var value = parseInt(match[1], 16);
    return [(value >> 16) & 0xff, (value >> 8) & 0xff, value & 0xff];
};
var toHexChannel = function (channel) {
    return Math.round(channel).toString(16).padStart(2, "0");
};
/**
 * Linearly mixes two 6-digit hex colors. `weight` is the share of `to` in
 * the result: 0 returns `from`, 1 returns `to`, 0.25 is a quarter of the way
 * from `from` to `to`. Useful for shades the palette does not define.
 */
export var mixHexColors = function (from, to, weight) {
    var w = Math.min(Math.max(weight, 0), 1);
    var a = parseHexColor(from);
    var b = parseHexColor(to);
    var mixed = a.map(function (channel, i) { return channel + (b[i] - channel) * w; });
    return "#".concat(mixed.map(toHexChannel).join(""));
};
